// Which way this page runs proxied sites (docs/security/PHASE1-PLAN.md, Stages C and D): on the
// sandbox origin view.<zone> through the engine host (tier A, app/engine-bridge.js), or in this
// page's own origin as before Phase 1 (legacy: sbx off, not in the canary, a BYOD host, or S did
// not answer).
//
// With sbx off nothing here makes a request: the server's switch arrives on the presence beacon
// (presence.js re-emits it as "rv:sbx") and is only noted while it is not "off". Only then does a
// later load ask /account/config where S is (engine-bridge.js checks the answer before using it).
// With sbx "canary", this browser is in the canary when the hash of its anonymous presence id is
// under the published share, so it does not flip between origins from one load to the next.
// While the switch is not off, each load reports the tier it ran once (POST /__rv/sbx-tier).
import { accountConfig, isSignedIn } from "./account.js";

const HINT = "rv:sbx";
const PID = "revault:pid";

function note(v) {
	try {
		if (v === "on" || v === "canary") localStorage.setItem(HINT, v);
		else if (v === "off") { localStorage.removeItem(HINT); localStorage.removeItem("rv:sbx-tier"); }
	} catch { /* storage off */ }
}
if (typeof window !== "undefined") window.addEventListener("rv:sbx", (e) => note(e.detail));

// FNV-1a 32-bit of a string, as a number in [0, 1). Deterministic per id.
export function hashToUnit(s) {
	let h = 0x811c9dc5;
	for (let i = 0; i < s.length; i++) { h ^= s.charCodeAt(i); h = Math.imul(h, 0x01000193) >>> 0; }
	return h / 4294967296;
}
// Is this anonymous id in a canary of share `fraction` (0..1)? No id: not in it.
export function inCanary(id, fraction) {
	const f = Number(fraction);
	return typeof id === "string" && id.length > 0 && Number.isFinite(f) && f > 0 && hashToUnit(id) < Math.min(1, f);
}

const pid = () => { try { return localStorage.getItem(PID) || ""; } catch { return ""; } };

// The tier this load ran, reported once ("A", "legacy" or "failed"). Anonymous: the presence id.
let reported = false;
export function reportTier(tier) {
	if (reported) return;
	reported = true;
	try { fetch("/__rv/sbx-tier", { method: "POST", keepalive: true, headers: { "content-type": "application/json" }, body: JSON.stringify({ id: pid() || "anon", tier }) }).catch(() => {}); } catch { /* offline */ }
}

export const signedIn = () => isSignedIn();

// The sandbox origin the server named for this load, or "" for legacy.
export async function sandboxOrigin() {
	let hint = null, failed = false;
	try { hint = localStorage.getItem(HINT); failed = !!sessionStorage.getItem("rv:sbx-failed"); } catch { return ""; }
	if (!hint) return "";
	if (failed) { reportTier("legacy"); return ""; }
	const c = await accountConfig();
	note(c.sbx);
	const origin = typeof c.sandboxOrigin === "string" ? c.sandboxOrigin : "";
	const use = !!origin && (c.sbx === "on" || (c.sbx === "canary" && inCanary(pid(), c.sbxFraction)));
	if (!use && (c.sbx === "on" || c.sbx === "canary")) {
		reportTier("legacy");
		try { localStorage.removeItem("rv:sbx-tier"); } catch { /* storage off */ } // left the canary: Settings shows no Secure mode row
	}
	return use ? origin : "";
}
